import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";

export class PromoClickAnalyticsEvent extends ClickEvent {
  constructor(params: PromoClickAnalyticsEvent) {
    super('', 'click', 'promo');

    this.source = params.source;
    this.promoName = params.promoName;
  }

  get properties(): Object {
    const properties = super.properties;

    properties.source = this.source;
    properties.promoName = this.promoName;

    return properties;
  }
}